import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Button from '~/components/core/Atomic/Buttons/Button';
import LEGACY_ORG_FEATURES from '~/server_shared/generated-types/LEGACY_ORG_FEATURES';

import { isBoostOrganization, isLegacyOrgFeatureEnabled } from '../../Utils';
import CardDialog from '../CardDialog';
import { useCms } from '../hooks/useCms';
import OrganizationSelectFormik from '../OrganizationSelect';

import BoostFnolScreen from './BoostFnolScreen';
import FnolScreen from './FnolScreen';
import MgmFnolScreen from './MgmFnolScreen';

import { useStyles } from '../../assets/styles';
import styles from './FnolContainer.module.scss';

const FnolContainerInner = () => {
  const { user, userOrganization, setPageTitle } = useCms();
  const [organization] = useState(user.is_super_organization ? undefined : userOrganization);
  const fnolInboxEleRef = useRef(null);

  const onFnolInboxExpand = () => {
    setTimeout(() => {
      if (fnolInboxEleRef.current) {
        fnolInboxEleRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 800);
  };

  useEffect(() => {
    setPageTitle('New Loss', 'FNOL — Five Sigma CMS');
  }, [setPageTitle]);

  if (!organization) {
    return null;
  }

  if (isLegacyOrgFeatureEnabled(organization, LEGACY_ORG_FEATURES.HOSPITALITY_FNOL_SCREEN)) {
    return <MgmFnolScreen organization={organization} />;
  } else if (isBoostOrganization(organization)) {
    return <BoostFnolScreen organization={organization} />;
  } else {
    return (
      <>
        <FnolScreen onFnolInboxExpand={onFnolInboxExpand} />
        <div ref={fnolInboxEleRef} />
      </>
    );
  }
};

const FnolContainer = () => (
  <div className={styles.fnolContainer}>
    <FnolContainerInner />
  </div>
);

function OrganizationSelectDialog(props) {
  const { onCancel, onSelectOrganization, isDialog } = props;
  const { classes } = useStyles();
  return (
    <Formik
      initialValues={{
        organization: '',
      }}
      validationSchema={Yup.object().shape({
        organization: Yup.object().required('Required'),
      })}
      onSubmit={(values) => onSelectOrganization(values['organization'])}
    >
      {(formikProps) => {
        const { isSubmitting, handleSubmit } = formikProps;
        return (
          <CardDialog
            isDialog={isDialog}
            title="Select Organization"
            maxWidth="sm"
            width="400px"
            onClose={onCancel}
            preventClose={isSubmitting}
          >
            <OrganizationSelectFormik id="organization" label="Organization" />
            <div className={classes.buttonsContainer}>
              <Button variant="contained" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
                Select
              </Button>
            </div>
          </CardDialog>
        );
      }}
    </Formik>
  );
}

OrganizationSelectDialog.propTypes = {
  onSelectOrganization: PropTypes.func.isRequired,
  isDialog: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
};

export default FnolContainer;
export { OrganizationSelectDialog };
